import type { AxiosInstance } from 'axios'
import axios from 'axios'
import {
	createContext,
	type PropsWithChildren,
	useContext,
	useMemo,
} from 'react'
import { baseURL as defaultBaseURL } from './api'
import { createClientInstance } from './client'

export interface ApiProviderValue {
	baseURL: string
	/**
	 * @deprecated The method should not be used, use `client` instead.
	 */
	axios: AxiosInstance
	client: ReturnType<typeof createClientInstance>
}

const Context = createContext<ApiProviderValue>({
	baseURL: defaultBaseURL,
	axios: axios.create({
		baseURL: defaultBaseURL,
		withCredentials: true,
	}),
	client: createClientInstance({
		baseUrl: defaultBaseURL,
	}),
})

export const useApi = () => {
	const value = useContext(Context)

	// if (!value) {
	//   throw Error(`useApi should be called within an ApiProvider`)
	// }

	return value
}

export default function Provider({
	baseURL = defaultBaseURL,
	...props
}: PropsWithChildren<{ baseURL?: string }>) {
	const value = useMemo(
		() => ({
			baseURL,
			axios: axios.create({
				baseURL,
				withCredentials: true,
			}),
			client: createClientInstance({
				baseUrl: baseURL,
			}),
		}),
		[baseURL],
	)

	return <Context.Provider {...props} value={value} />
}

export { Provider as ApiProvider }
